import React from 'react'
import { useTranslate } from '../src/hooks/useTranslate'
import { ProductUnit } from '../src/model/fragments'
import { Tooltip } from 'react-tooltip'
import SvgQuestionMark from './icons/SvgQuestionMark'

export interface ParametersProps {
	id?: string
	palletType?: string
	weightPerSquareMeter?: number
	quantityPerPallet?: number
	squareMeterPerPallet?: number
	palletLayerSquareMeter?: number
	palletLayerQuantity?: number
	quantityPerSqm?: number
	palletWeight?: number
	unit?: string
}

interface Item {
	label: string
	value: string | number
	tooltip?: string
}

export const Parameters: React.FunctionComponent<ParametersProps> = ({
	id,
	palletType,
	weightPerSquareMeter,
	squareMeterPerPallet,
	quantityPerPallet,
	palletLayerSquareMeter,
	palletLayerQuantity,
	palletWeight,
	quantityPerSqm,
	unit,
}) => {
	const translate = useTranslate()

	const pallet = palletType?.replace(/^paleta/i, '').trim()

	const items: Item[] = [
		['ID', id],
		[translate('pallet-size'), pallet, translate('pallet-size-tooltip')],
		[translate('measurement-unit'), unit && translate(`unit-${unit}`)],
		[
			translate('pallet') + ` (${unit === ProductUnit.item ? 'ks' : 'm²'})`,
			unit === ProductUnit.item ? quantityPerPallet : squareMeterPerPallet,
		],
		[
			unit === ProductUnit.item ? `${translate('weight')} (kg)` : `${translate('weight')} (kg/m²)`,
			weightPerSquareMeter,
		],
		[`${translate('pallet-weight')} (kg)`, palletWeight],
		...(unit === ProductUnit.item
			? []
			: [[translate('pallet-layer-quantity'), palletLayerQuantity]]),
		[`${translate('count')} (ks/m²)`, quantityPerSqm],
		...(unit === ProductUnit.item
			? []
			: [[`${translate('pallet-layer')} (m²)`, palletLayerSquareMeter]]),
	]
		.filter(
			(it): it is [string, string | number, string?] =>
				it[1] !== undefined && it[1] !== null,
		)
		.map(([label, value, tooltip]) => ({ label, value, tooltip }));

	return (
		<div className="parameters">
			<Tooltip anchorSelect=".parameters-item-tooltip" />
			{items.map((item, i) => (
				<div className="parameters-item" key={i}>
					<div className="parameters-item-label">
						{item.label}
					</div>
					<div className="parameters-item-value">
						{item.value}
						{
							item.tooltip && <>
								<a className='parameters-item-tooltip' data-tooltip-content={item.tooltip}><SvgQuestionMark /></a>
							</>
						}
					</div>
				</div>
			))}
		</div>
	)
}
